import { DEVICE_TYPE_TO_CAMPAIGN_INFO_CODE_MAPPING, DeviceType, CampaignCode } from "../constants";

/**
 * Takes a deviceType and returns it's mapped campaign info code
 * or undefined it is not found
 * @param {DeviceType} deviceType
 * @returns {string | undefined}
*/

const getCampaignInfoCode = (deviceType: DeviceType): CampaignCode | undefined => {
  if (deviceType in DEVICE_TYPE_TO_CAMPAIGN_INFO_CODE_MAPPING) {
    return DEVICE_TYPE_TO_CAMPAIGN_INFO_CODE_MAPPING[deviceType]
  }
}

export { getCampaignInfoCode }
